import { videos, documents } from "./TeachersToolkitTraining.consts";
import { TTTElement } from "./components/TTTElement/TTTElement";
import { TabMargin } from "../components/TabMargin";
import { Box } from "@material-ui/core";
import React from "react";
import {
  TTTSectionSubTitle,
  TTTContentWrapper,
  TTTSectionTitle,
  TTTSectionText,
  TTTContainer,
  TTTElements,
} from "./TeachersToolkitTraining.styled";

export const TeachersToolkitTraining = () => {
  return (
    <TTTContainer>
      <TTTContentWrapper>
        <TabMargin />
        <TTTSectionTitle>Teacher Training Resources</TTTSectionTitle>
        <TTTSectionText>
          To make the most of what Solar Schools has to offer, we've created
          handy video and PDF tutorials to assist you.
        </TTTSectionText>
        <TTTSectionText>
          Browse our selection below to get started.
        </TTTSectionText>
        {/* Videos */}
        <br />
        <TTTSectionSubTitle>Videos</TTTSectionSubTitle>
        <br />
        <TTTElements>
          {videos.map((video, index) => (
            <TTTElement key={index} type="video" resource={video} />
          ))}
        </TTTElements>

        {/* PDF Guides */}
        <TTTSectionSubTitle>PDF Guides</TTTSectionSubTitle>
        <br />
        <TTTElements>
          {documents.map((document, index) => (
            <TTTElement key={index} type="document" resource={document} />
          ))}
        </TTTElements>
        <Box marginTop={5}>
          <TTTSectionText>More resources coming soon.</TTTSectionText>
        </Box>
      </TTTContentWrapper>
    </TTTContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/TeachersToolkitTraining.js